module.exports = {
    api: "https://api.clomos.es",
    name: "D&A Innovative Systems"
}